import { faBan } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { isLoading as Loading, LoadingTypes } from '@labrav/common'
import {
  ButtonV2,
  ModalConfirmV2,
  ModalSizeVariants,
} from '@labrav/react-components'
import { useSelector } from 'react-redux'
import type { ComponentLoadingState } from '@labrav/common'
import { useStyles } from './ViewFreeTrial.styles'

type LoadingRootState = {
  loading: ComponentLoadingState
}

export type DeActivateModalProps = {
  openConfirmModal: boolean
  handleCloseConfirmModal: () => void
  handleDeactivate: () => void
}

export const DeActivateModal = ({
  openConfirmModal,
  handleCloseConfirmModal,
  handleDeactivate,
}: DeActivateModalProps) => {
  const { classes } = useStyles()
  const isLoadingState = useSelector((state: LoadingRootState) =>
    Loading(state.loading)(LoadingTypes.DEACTIVATE_FREE_TRIAL)
  )
  return (
    <ModalConfirmV2
      maxWidth={'500px'}
      title={'Deactivate free trial?'}
      open={openConfirmModal}
      onDecline={handleCloseConfirmModal}
      onAccept={handleDeactivate}
      variant={ModalSizeVariants.medium}
      content={
        <>
          <div className={classes.confirmDeActivateDesc}>
            Do you want to deactivate free trial?
          </div>
          <div className={classes.rowRightItem}>
            <ButtonV2
              data-testid="cancel-btn"
              smallVariant
              styleType="outlined"
              onClick={handleCloseConfirmModal}
            >
              Cancel
            </ButtonV2>
            <ButtonV2
              data-testid="deactivate-btn"
              smallVariant
              styleType="primary"
              onClick={handleDeactivate}
              loading={isLoadingState}
            >
              Deactivate
            </ButtonV2>
          </div>
        </>
      }
      titleAcceptButton={'Deactivate'}
      hideCancelButton={true}
      hideAcceptButton={true}
      icon={
        <FontAwesomeIcon
          icon={faBan}
          style={{ width: '20px', height: '16px' }}
        />
      }
    />
  )
}
